import { useGraphqlQuery } from "@bsm/component"
import { TUserStudentFamily } from "@bsm/graphql"
import { UserStudentFamilyQuery } from "../queries/UserStudentFamilyQuery"

export const useUserStudentFamilyQuery = (id?: number, suspense?: boolean) => {
    return useGraphqlQuery<UserStudentFamilyQuery, TUserStudentFamily>(new UserStudentFamilyQuery({ id }), { enabled: id !== undefined, suspense })
}
